import './AboutUs.styles.scss';

import React from 'react';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';

const AboutUsPage = () => {
	DocTitleScrollTop('About Us');

	return (
		<div className="myPage aboutUsPage">
			<div className="mfaContainer">
				<h1>About Us</h1>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid quod
					praesentium obcaecati dolore, fugit blanditiis corporis doloribus ea
					hic similique recusandae sit voluptas debitis ipsa vero sint
					voluptates nihil cumque. Lorem ipsum dolor sit amet, consectetur
					adipisicing elit. Aliquid quod praesentium obcaecati dolore, fugit
					blanditiis corporis doloribus ea hic similique recusandae sit voluptas
					debitis ipsa vero sint voluptates nihil cumque. Lorem ipsum dolor sit
					amet, consectetur adipisicing elit. Aliquid quod praesentium obcaecati
					dolore, fugit blanditiis corporis doloribus ea hic similique
					recusandae sit voluptas debitis ipsa vero sint voluptates nihil
					cumque. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
					Aliquid quod praesentium obcaecati dolore, fugit blanditiis corporis
					doloribus ea hic similique recusandae sit voluptas debitis ipsa vero
					sint voluptates nihil cumque.
				</p>
			</div>
		</div>
	);
};

export default AboutUsPage;
